import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
import { dynamicDispatcher } from "@/libs/util";


export const loginApi = ({ user, password, key }) => {
  return axios.request({
    url: "Core/LoginApi",
    params: {
      user: user,
      password: password,
      key: key
    },
    method: "post"
  });
};

export const requestApi = ({ api, method, data, params }) => {
  //console.log(params);
  return axios.request({
    url: "Core/RequestApi",
    params: params,
    data: {
      api: api,
      method: method,
      token: getToken(),
      data: data
    },
    method: "post"
  });
};

export const requestUploader = ({ file, params }) => {
  let formData = new FormData();
  //console.log(file);
  formData.append("file", file);
  //console.log(formData);
  // for (var key of formData.entries()) {
  //   console.log(key[0] + ', ' + key[1]);
  // }
  return axios.request({
    url: "Core/uploader",
    params: params,
    formData,
    
    
    // data: {
    //   api: api,
    //   method: method,
    //   token: getToken(),
    //   data: data
    // },
    method: "post"
  });
};

export const getUserInfo = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "User/get_info",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const servertime = () => {
  return new Promise(resolve => {
    requestApi({
      api: "servertime",
      method: "get",
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getGroupDefaultProjects = ({store}) => {
  return new Promise(resolve => {
    requestApi({
      api: "Config/GetDefaultProjects",
      method: "get",
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getPersonalSettings = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Config/GetPersonalSettings",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};